import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const AvatarWrapper = styled.div`
    padding: ${(props) => (props.outline ? '4px' : 0)};
    border: ${(props) => (props.outline ? `1.5px solid ${props.borderColor}` : 'none')};
    border-radius: 100%;
`;

const NameAvatar = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: ${(props) => `${props.width || 32}px`};
  height: ${(props) => `${props.height || 32}px`};
  font-size: ${(props) => (props.width > 32 ? '16px' : '10px')};
  font-weight: 600;
  text-align: center;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
`;

function Avatar({
  src,
  name,
  width,
  height,
  color,
  borderColor,
  backgroundColor,
  outline = false,
}) {
  const [errored, setErrored] = useState(false);

  // Reset the error flag if the source changes (e.g. list re-renders)
  useEffect(() => setErrored(false), [src]);

  const showImage = src && !errored;

  return (
    <AvatarWrapper outline={outline} borderColor={borderColor}>
      {
            showImage ? (
              <img
                src={src}
                width={width}
                height={height}
                style={{ borderRadius: '100%', objectFit: 'cover', display: 'block' }}
                alt={name}
                onError={() => setErrored(true)}
              />
            )
              : (
                <NameAvatar
                  width={width}
                  height={height}
                  backgroundColor={backgroundColor}
                  color={color}
                >
                  {name}
                </NameAvatar>
              )
        }
    </AvatarWrapper>
  );
}

Avatar.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  borderColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  outline: PropTypes.bool,
};

export default Avatar;
